const posts = [
  {
    slug: 'are-introduction',
    title: 'ARE: A Config-Driven Approach to Interactive Environments',
    summary: '',
    publishedAt: '2026-06-26',
    markdownPath: '/blog content/are-introduction.md',

    // Optional
    tags: [],
    projectSlug: 'adaptive-room-environment',
  },
  {
    slug: 'gt-cs-6750-hci',
    title: 'CS 6750: Human-Computer Interaction',
    summary: '',
    publishedAt: '2026-10-22',
    markdownPath: '/blog content/gt-cs-6750-hci.md',

    // Optional
    tags: [],
    projectSlug: 'georgia-tech',
  }

  /*   {
    slug: "test-project-overview",
    title: "[TEST] Project overview article",
    summary:
      "First related article for the complete project-content test.",
    publishedAt: "2026-01-15",
    markdownPath: "/blog content/are-introduction.md",
    tags: ["Test", "Overview"],
    projectSlug: "test-all-project-content",
  },
  {
    slug: "test-project-deep-dive",
    title: "[TEST] Project deep-dive article",
    summary:
      "Second related article for testing multiple articles and project navigation.",
    publishedAt: "2026-02-20",
    markdownPath: "/blog content/are-introduction.md",
    tags: ["Test", "Technical"],
    projectSlug: "test-all-project-content",
  }, */
];

export default posts;